import {graphql, Link, StaticQuery} from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import Footer from '../Footer'
import Header from '../Header'
import CookieBar from '../CookieBar'

export const Layout = ({children}) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
            siteUrl
            version
          }
        }
      }
    `}
    render={data => (
      <>
        <Header siteTitle={data.site.siteMetadata.title} />
        <div
          style={{
            margin: `0 auto`,
            maxWidth: 960,
            padding: `0px 1.0875rem 1.45rem`,
            paddingTop: 0,
          }}
        >
          {children}
          <Footer>
            © <Link to={`/`}>{data.site.siteMetadata.title}</Link>{' '}
            {new Date().getFullYear()}
            <br />
            {data.site.siteMetadata.version}
          </Footer>
          <CookieBar />
        </div>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}
